import { render, staticRenderFns } from "./yearRange.vue?vue&type=template&id=251c2434&scoped=true&"
import script from "./yearRange.vue?vue&type=script&lang=js&"
export * from "./yearRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251c2434",
  null
  
)

export default component.exports